import Header from '../components/Header';
import Hero from '../components/Hero';
import PainPoints from '../components/PainPoints';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import Safety from '../components/Safety';
import Solutions from '../components/Solutions';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import SectionNav from '../components/SectionNav';
import StickyCta from '../components/StickyCta';
import { useEffect } from 'react';
import { SectionDivider } from '../components/ui/Ui';
import { PRODUCT, defaultPack } from '../data/product';
import { trackViewContent } from '../lib/pixel';

/**
 * ترتيب الأقسام يتبع رحلة القرار لا ترتيب المعلومات:
 *
 *  1) الهيرو    → الوعد والسعر والزر؛ من قرّر الشراء لا يُطلب منه أن يقرأ
 *  2) الألم     → «هذه مشكلتي بالضبط» فيكمل القراءة
 *  3) الفيديو   → يراه يعمل؛ الرؤية تُقنع أسرع من ثلاث فقرات
 *  4) المحادثات → أقوى ورقة في الصفحة، وبعدها زر الشراء مباشرة
 *  5) المميزات والأمان والاستخدامات → لمن بقي مرحلة متردداً
 *  6) الأسئلة   → آخر ما يلتقط المتردد قبل مغادرته
 *
 * المحادثات كانت سابعة، وأغلب الزوار لا يصلون إلى القسم السابع. الزائر الآتي
 * من إعلان لا يعرفنا، وسؤاله الأول ليس «كم واط» بل «هل هؤلاء ناس حقيقيون» —
 * فتقديمها إلى الرابع يضعها حيث يُطرح السؤال فعلاً.
 *
 * الشريط الثابت يبقى ظاهراً طوال التمرير فيغني عن قسم إغلاق في النهاية.
 */
export default function HomePage() {
  // ViewContent: الصفحة كلها صفحة منتج واحد، فمجرّد فتحها هو مشاهدة للمنتج
  useEffect(() => {
    trackViewContent(PRODUCT.price);
  }, []);

  // اختيار الكمية صار داخل صفحة الطلب، فالشريط الثابت يعرض الباقة الافتراضية
  return (
    <>
      <Header />
      {/* الفاصل الزخرفي بين الأقسام البيضاء فقط — تغيّر الخلفية عند الأقسام
          الكحلية (الأمان والإغلاق) يقوم بدور الفاصل بنفسه */}
      <main>
        <Hero />
        <SectionDivider />
        <PainPoints />
        <SectionDivider />
        <HowItWorks />
        <SectionDivider />
        <Testimonials />
        <SectionDivider />
        <Features />
        <Safety />
        <Solutions />
        <SectionDivider />
        <FAQ />
      </main>
      <Footer />
      <SectionNav />
      <StickyCta pack={defaultPack} />
    </>
  );
}
